import { Injectable } from '@angular/core';
import { HttpApiService } from '../services/http-api.service';

@Injectable({
  providedIn: 'root',
})
export class FixTransactionBetService {
  constructor(private http: HttpApiService) {}

  makeCannelBet(value: any) {
    return this.http.post('support/game/cancel-bet', value);
  }
}
